module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tActions\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, [_c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "ctn-actions row"
  }, [_c('div', {
    staticClass: "btn btn-red ctn-icon",
    class: {
      'btn-disabled': !_vm.canCancel
    },
    on: {
      "click": function($event) {
        return _vm.cancelSubscription()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tAnnuler l'abonnement\n\t\t\t\t")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2322a88d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MySubscriptions/EditForm/Actions.vue
// module id = 1083
// module chunks = 0